/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { selectComposerContentOnly, selectComposerEditMode } from "data/store/reducers/composer";
import { useSelector } from "react-redux";


const useComposerMode = () => {
    const contentOnly = useSelector(selectComposerContentOnly);
    const editMode = useSelector(selectComposerEditMode);

    return {
        contentOnly,
        editMode
    };
};

export { useComposerMode };
